// components/Icons.jsx
import { IdentificationIcon, EnvelopeIcon, BuildingStorefrontIcon } from '@heroicons/react/24/outline';

export const RationCardIcon = () => (
  <IdentificationIcon className="h-5 w-5 text-gray-400" />
);

export const LicenseIcon = () => (
  <IdentificationIcon className="h-5 w-5 text-gray-400" />
);

export const ShopIcon = () => (
  <BuildingStorefrontIcon className="h-5 w-5 text-gray-400" />
);